module.exports = __webpack_public_path__ + "img/m-menu.302a780a.svg";